<template>
  <div class="tw:flex tw:flex-col tw:gap-2 tw:p-4">
    <div class="tw:flex tw:items-center tw:gap-2">
      <div
        class="tw:flex tw:flex-1 tw:gap-2 tw:rounded-[25px] tw:border tw:border-solid tw:border-denim-300 tw:p-2"
      >
        <div class="tw:flex tw:items-center">
          <AIIcon />
        </div>
        <div class="tw:relative tw:flex tw:flex-1 tw:items-center">
          <InputText
            ref="input"
            v-model="inputText"
            auto-focus
            auto-grow
            borderless
            class="tw:flex-1"
            data-testid="input-text"
            :disabled="loading"
            input-classes="tw:p-0!"
            :max-height="132"
            :min-height="16"
            new-design
            :placeholder="placeholder"
            type="textarea"
            @keydown="handleKeydown"
          />
        </div>
        <slot name="after" />
      </div>
      <div>
        <BaseButton
          circle
          color="ai"
          data-testid="send-button"
          :disabled="isSendButtonDisabled"
          flat
          icon="send"
          new-design
          new-icon
          @click="emit('submit')"
        />
      </div>
    </div>
    <div
      class="tw:text-center tw:text-[10px] tw:leading-[14px] tw:tracking-tight tw:text-denim-600"
      data-testid="disclaimer"
    >
      {{
        getLocaleText("ai_assistant_panel.footer_text", {
          aiAssistant: appConfig.aiAssistant,
        })
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed, useTemplateRef } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import AIIcon from "shared/components/AI/AIIcon.vue";
import { BaseButton, InputText } from "shared/components/base";
import useGlobalStore from "shared/stores/global";

interface AIAssistantBaseChatInputProps {
  loading?: boolean;
  placeholder?: string;
}

const { loading, placeholder = "" } =
  defineProps<AIAssistantBaseChatInputProps>();

const emit = defineEmits<{
  submit: [];
}>();

const { appConfig } = storeToRefs(useGlobalStore());

const input = useTemplateRef("input");
const inputText = defineModel<string>({ default: "" });

const isSendButtonDisabled = computed(() => !inputText.value.trim() || loading);

function focus(): void {
  input.value?.focus();
}

function handleKeydown(event: KeyboardEvent) {
  if (!event.shiftKey && event.key === "Enter") {
    event.preventDefault();
    emit("submit");
  }
}

defineExpose({
  focus,
});
</script>
